/**
 * Chave de campo → o nome que a pessoa lê.
 *
 * Mesma disciplina de `ROTULOS_DO_ITEM_DA_PENDENCIA`: o token é do modelo, o
 * rótulo é de gente. Mostrar `nome_beneficiario` na tela é vazar nome de
 * coluna para quem opera.
 *
 * Fica em código, e não na curadoria, porque é vocabulário COMPARTILHADO: a
 * mesma chave quer dizer a mesma coisa em toda operadora. O que é curadoria é
 * QUAIS chaves cada passo exige — isso vive em `config_passo.campos_exigidos`.
 */
export const ROTULO_DO_CAMPO: Record<string, string> = {
  endereco: 'Endereço de casa',
  bairro_cep_regiao: 'Bairro · CEP · região de casa',
  hospital_leito: 'Hospital · andar · leito',
  telefone_cuidador: 'Telefone do cuidador',
  telefone: 'Telefone',
  falou_com: 'Falou com',
  data_nascimento: 'Data de nascimento',
  numero_cartao: 'Número do cartão',
  nome_beneficiario: 'Nome do beneficiário',
  diagnostico: 'Diagnóstico',
  pad_anterior: 'PAD anterior',
  liminar: 'Liminar',
  ja_assistido: 'Já assistido pela Anery',
  cooperativa: 'Cooperativa',
  profissional: 'Profissional',
  comunicado_por_especialidade: 'Um comunicado por especialidade do PAD',
  valor_proposto: 'Valor proposto',
  disponivel_em: 'Disponível a partir de',
  data_avaliacao_residencia: 'Data da avaliação da residência',
  tcle_assinado: 'TCLE assinado pelo responsável',
  pdf_pad: 'PDF do PAD enviado pela operadora',
  processo_inicial: 'Processo Inicial (carta à operadora)',
  termo_solicitacao_id: 'Termo de Solicitação de Internação Domiciliar, assinado',
  programa_id: 'Programa de Internação Domiciliar (guia oficial)',
  prescricao: 'Prescrição — dieta, medicamentos e materiais',
  formulario_avaliacao: 'Formulário de Avaliação (COREN · NEAD)',
  orcamento: 'Orçamento',
  comunicado_implantacao: 'Comunicado de Implantação, com hora',
  guia_tiss: 'Guia TISS',
  nota_fiscal: 'Nota fiscal',
  leitura_pedido_medico: 'O que a leitura entendeu do pedido médico',
  acao_escala: 'A escala não voltou dentro das 3h',
  decisao_pad_fechado: 'Decisão da Gerência sobre o PAD fechado',
  decisao_margem: 'Exceção de margem — alçada da Diretoria',
  motivo_declinio: 'Justificativa padronizada do declínio',
  conferencia_handoff: 'Conferir antes de receber o caso',
  justificativa: 'Justificativa',
  pendencias_abertas: 'Pendências que ficam abertas',
  observacao: 'Observação',
};
